import { EmptyState } from '../lib/EmptyState.js';
import { LinkButton } from '../lib/ui.js';
import { appText } from '../state/session.js';

/** Pagina bestaat niet (DESIGN.md §8.X): vriendelijke illustratie, geen schuld, één actie. */
export function NotFoundPage() {
  const a = appText.value;
  return (
    <main class="auth-page not-found" data-name="not-found">
      <EmptyState
        heading="h1"
        title={a.notFoundTitle}
        body={a.notFoundBody}
        action={
          <LinkButton href="/vandaag" variant="primary" icon="house">
            {a.toToday}
          </LinkButton>
        }
      />
    </main>
  );
}
